module.exports = __webpack_public_path__ + "article-7051a3ee/sprachkenntnisse-lebenslauf-e09e8ed8a76218440c4a1f0e9cbdb223.jpg";